import React from 'react';
import {HashLink as Link} from "react-router-hash-link";
import BBExternalLink from "../../components/customBreachBits/accents/BBExternalLink";



export const BRfPortfolioTourManage ={
    url: `/board/BreachRisk/Portfolio/Manage`,
    type: `tutorial`,
    user: {
        first_login: true,
        // first_time_on_page: true,
        // manager: true,
    },
    entity: {
        // verified_ownership: false,
        // subscription: "Portfolio",
        // subLevel: ["pro"],
        hasScores: null,
    },
    openingModal: {
        icon: null,
        heading: "Tour Manage Portfolio?",
        description: <div className={"text-center"}>
            <h3>

            </h3>
            <p>Use this page to manage what companies are in your portfolio, portfolio groups, and to request access to a company's report.</p>
        </div>
    },
    tourSteps: {
        1: {
            step: 1,
            title: "All Companies",
            placement: "top",
            content: <>
                <p>Take a look at and manage all the companies in your portfolio. </p>
            </>,
            scrollToElement: "#tourPortfolioEntitiesTable",
            anchorEl: "#tourPortfolioAllCompaniesCol",
            // element: document.getElementsByClassName("tourTable"),
            last: false,
        },
        2: {
            step: 2,
            title: "Number of Companies in Portfolio ",
            placement: "left",
            content: <>
                <p>How many companies you can add to your portfolio is determined by your company's BreachRisk&trade; subscription level and agreement.</p>
            </> ,
            anchorEl: "#tourNumberCompanies",
            scrollToElement: "#tourPortfolioEntitiesTable",
            element: document.getElementsByClassName("tourNumberCompanies"),
            last: false,
        },
        3: {
            step: 3,
            title: "Add Company To Portfolio",
            placement: "left",
            content:<>
                <p>
                    Add a company to portfolio. You will need the company name and their official website. They will automatically be added to your portfolio.
                </p>
                <p>You will have access to their BreachRisk&trade; as soon as the first scores become available. Some companies will already have a score available, others may take a couple of hours.</p>
                <p><em>A company will not be notified that they've been added to your portfolio. You'll automatically be granted access to their Score, but will need permission to access their Report.</em></p>
            </> ,
            anchorEl: "#tourAddCompanyToPort",
            scrollToElement:"#tourPortfolioEntitiesTable",
            element: document.getElementsByClassName("tourAddCompanyButton"),
            last: false,
        },
        4: {
            step: 4,
            title: "Report Access",
            placement: "left",
            content: <>
                <p>Make a sharing request by clicking this button. If the button is inactive, you have already made a request and are either waiting for approval or have already been granted access. </p>
                <p>
                    A sharing request will invite anyone not already using Breachrisk&trade; to create an account. Those already associated with the service will get a request on their dashboard that they can approve or reject.</p>
                <p>
                    You'll need the email address for the company's Point of Contact to make your request.
                </p>
            </> ,
            anchorEl: "#tourActionsSharingRequest",
            scrollToElement: "#tourPortfolioEntitiesTable",
            element: document.getElementsByClassName("tourActionsSharingElement"),
            last: false,
        },
        5: {
            step: 5,
            title: "Add Company To A Subportfolio",
            placement: "left",
            content:<>
                <p>
                    Add this company to an existing Subportfolio group. Subportfolios allow you to organize and compare companies based on your best business practices and interests. Companies can be in multiple subportfolios.
                </p>
                <p>
                    Learn more about how you might utilize this feature <BBExternalLink href={"https://support.breachbits.com/knowledge/make-subportfolio-group"} className={"text-white"}><u>on our Knowledge Base </u></BBExternalLink>.
                </p>
            </> ,
            anchorEl: "#tourActionSubportfolio",
            scrollToElement:"#tourPortfolioEntitiesTable",
            element: document.getElementsByClassName("tourActionSubportfolioElement"),
            last: false,
        },
        6: {
            step: 6,
            title: "Remove Company From Portfolio",
            placement: "left",
            content: <>
                <p>Remove a company from your portfolio. This will remove it from any subportfolios it might be in.</p>
                <p>Companies can always be added back later.</p>
            </>,
            anchorEl: "#tourActionArchive",
            scrollToElement: "#tourPortfolioEntitiesTable",
            element: document.getElementsByClassName("tourActionArchiveElement"),
            last: false,
        },
        7: {
            step: 7,
            title: "Portfolio Groups",
            content:<>
                <p>
                    Take a look at and manage different subportfolios, if you have any created.
                </p>
                <p>
                </p>
            </>,
            anchorEl: "#tourPortfolioGroupsHeader",
            // element: document.getElementsByClassName("tourStepBRPortfolioInsightsScores"),
            scrollToElement: null,
            last: false,
        },
        8: {
            step: 8,
            title: "Create A New Subportfolio",
            content:<>
                <p>
                    Click this button to create a new subporfolio. Subportfolios are designed to meet your needs as you analyze across your portfolio.
                </p>
                <p>
                    Companies can be in multiple subportfolios and you can create as many subportfolios as you need.
                </p>
            </>,
            anchorEl: "#tourAddSubportfolioHeader",
            element: document.getElementsByClassName("tourAddSubportfolioButton"),
            scrollToElement: "#BRPSubportfoliosManagementTableSection",
            last: false,
        },
        9: {
            step: 9,
            title: "Data Sharing Requests",
            content:<>
                <p>
                    See any requests your company has made for Report access. See when the request was made and what the status is.
                </p>
                <p>
                </p>
            </>,
            anchorEl: "#tourSharingTableTitle",
            // element: document.getElementsByClassName("tourStepBRPortfolioInsightsScores"),
            scrollToElement: null,
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        boxShadow: 24,
        p: 4,
    }
}
